import { createSlice } from "@reduxjs/toolkit";

export const tboHotelSlice = createSlice({
    name: "tboHotels",
    initialState: {
        hotels: [],
        loading: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload; 
            if (action.payload) state.error = null;
        },
        setTboHotels: (state, action) => {
            state.loading = false;
            state.error = null;
            state.hotels = Array.isArray(action.payload) ? action.payload : [];
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

// Export actions
export const { setLoading, setTboHotels, setError } = tboHotelSlice.actions;

// Export reducer
export default tboHotelSlice.reducer;
